import { Card, CardContent, CardTitle } from 'components/ui/card';
import ListItems from './components/ListItems';
import { memo } from 'react';
import { LayoutDefault } from '@app/layouts';
import { Container } from '@app/components';

const PagePrivacy = () => {
  return (
    <LayoutDefault>
      <Container>
        <Card className="max-w-4xl mx-auto my-8">
          <CardContent>
            <CardTitle className="text-3xl font-bold text-center mb-8">
              Политика конфиденциальности
            </CardTitle>
            <div className="p-4 bg-white rounded-lg mb-8">
              Настоящее Положение об обработке персональных данных (далее –
              «Положение») издано и применяется ТОО «Bright Technologies» (далее
              – «Оператор») в соответствии с Законом Республики Казахстан от
              21.05.2013 №94-V «О персональных данных и их защите» и определяет
              основные положения, реализуемые при обработке персональных данных
              Оператором. Целью настоящего Положения является выполнение
              требований законодательства в области защиты персональных данных,
              основанного на Конституции Республики Казахстан и состоящего из
              Закона Республики Казахстан от 21.05.2013 №94-V «О персональных
              данных и их защите» и иных нормативных правовых актов,
              определяющих случаи и особенности обработки персональных данных.
            </div>
            <ListItems />
          </CardContent>
        </Card>
      </Container>
    </LayoutDefault>
  );
};

export default memo(PagePrivacy);
